import { useContext, useEffect, useState } from 'react';
import { PickingContext } from '../context/PickingContext';

// The mobile site: a layout for phones, chosen once as the page loads, so a desktop never sees it. A phone is a touch
// screen whose browser says it is a phone ("Mobile", or an iPhone): asking a phone's browser for the desktop site drops
// that, and gets the desktop site.
const Detected = () => /Mobi|iPhone|iPod/.test(navigator.userAgent) && !!window.matchMedia?.('(pointer: coarse)').matches;

export const IsMobile = Detected();

// (The menu once had a switch between the two, kept in the browser: forgotten, so the browser's own choice holds again)
try {
    localStorage.removeItem('tta-site');
} catch {
    // (no storage: nothing kept)
}

// Something shown on hover (a card, a list): [shown, setShown, props for what is hovered]. On a desktop, shown while
// the mouse is over it; on a phone, which has no hover, a tap shows it and it is closed from what it shows (see
// CardOverlay), or by a tap anywhere else (Closes: true, for small tips that have nothing to close them by). Never shown
// on a card the action bar is picking (see PickingContext).
export function useHover({ Closes = false } = {}) {
    const [hovered, setShown] = useState(false);
    const picking = useContext(PickingContext);
    const shown = hovered && !picking;
    useEffect(() => {
        if (!IsMobile || !Closes || !shown)
        {
            return undefined;
        }
        // (the tap that opened it has finished by now: only later ones close it)
        const close = () => setShown(false);
        document.addEventListener('pointerdown', close);
        return () => document.removeEventListener('pointerdown', close);
    }, [shown, Closes]);
    const props = IsMobile
        ? { onClick: () => setShown(true) }
        : { onMouseEnter: () => setShown(true), onMouseLeave: () => setShown(false) };
    return [shown, setShown, props];
}
